export class ChunkAssembler {
  private chunks = new Map<
    string,
    { parts: string[]; total: number; received: Set<number> }
  >();
  private readonly timeout = 30000; // 30 seconds
  private timers = new Map<string, ReturnType<typeof setTimeout>>();

  handleChunk(chunk: {
    chunkId: string;
    index: number;
    total: number;
    data: string;
  }): string | null {
    const { chunkId, index, total, data } = chunk;

    if (!this.chunks.has(chunkId)) {
      this.chunks.set(chunkId, {
        parts: Array.from<string>({ length: total }),
        total,
        received: new Set(),
      });

      const timer = setTimeout(() => {
        this.cleanup(chunkId);
      }, this.timeout);
      this.timers.set(chunkId, timer);
    }

    const collection = this.chunks.get(chunkId)!;

    collection.parts[index] = data;
    collection.received.add(index);

    if (collection.received.size === total) {
      clearTimeout(this.timers.get(chunkId));
      this.timers.delete(chunkId);
      this.chunks.delete(chunkId);

      const completeJson = collection.parts.join('');
      return completeJson;
    }

    return null;
  }

  private cleanup(chunkId: string) {
    this.chunks.delete(chunkId);
    const timer = this.timers.get(chunkId);
    if (timer) {
      clearTimeout(timer);
      this.timers.delete(chunkId);
    }
  }

  clear() {
    for (const [, timer] of this.timers) clearTimeout(timer);
    this.chunks.clear();
    this.timers.clear();
  }
}
